import { createFileRoute } from '@tanstack/react-router';

import UserDetails from '@/ui/pages/UserDetails/UserDetails';

export const Route = createFileRoute('/_dashboard/users/$id/$tenantId/')({
  component: UserDetails,
});
